import { createAction, createReducer, on } from "@ngrx/store";
import { IAnamneseChoosePopupModal } from "../models/anamnese-choose-popup-modal.model";

export const openCloseAnamneseChoosePopupModal = createAction('[Anamnese Choose Popup Modal] OpenClose')
export const setAnamneseExcludeProcessStatus = createAction('[Anamnese Choose Popup Modal] Set Anamnese Exclude Process Status', (status: boolean) => ({ status }))
export const setAnamneseChoosePopupType = createAction('[Anamnese Choose Popup Modal] Set Anamnese Choose Popup Type', (popupTypeObj: {}) => ({ popupTypeObj }))

export const initialState: IAnamneseChoosePopupModal = {
  isOpen: false,
  isExcluded: false,
  anamneseChoosePopupType: {}
};

export const anamneseChoosePopupModalReducer = createReducer<IAnamneseChoosePopupModal>(
  initialState,
  on(openCloseAnamneseChoosePopupModal, (state) => {
    return { ...state, isOpen : !state.isOpen }
  }),

  on(setAnamneseExcludeProcessStatus, (state, { status }) => {
    return { ...state, isExcluded: status }
  }),

  on(setAnamneseChoosePopupType, (state, { popupTypeObj }) => {
    return { ...state, anamneseChoosePopupType: popupTypeObj }
  })

);
